import { render, staticRenderFns } from "./MeetingManager.vue?vue&type=template&id=56b0b79c&scoped=true"
import script from "./MeetingManager.vue?vue&type=script&lang=js"
export * from "./MeetingManager.vue?vue&type=script&lang=js"
import style0 from "./MeetingManager.vue?vue&type=style&index=0&id=56b0b79c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b0b79c",
  null
  
)

export default component.exports